export default __webpack_public_path__ + "static/courtshape-4ce84cd301bc64a9e74d5299513bcd52.png";